import styled from 'styled-components';

export const Component = styled.div`
  position: relative;
`;

export const Container = styled.div`
  position: relative;
`;
